import {
	getPermalinkId,
	getPermalinkIdFromURL,
	COMMENTS,
} from '../../../../common/utils/permalinks.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default ({
	maxResults,
	startAt,
	orderBy,
	commentAmount,
	url,
}: {
	startAt: number;
	maxResults?: number;
	orderBy?: string;
	commentAmount?: number;
	url?: URL;
}) => {
	const commentPermalinkId = url ? getPermalinkIdFromURL(COMMENTS, url) : getPermalinkId(COMMENTS);

	const orderByParameter =
		orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';

	const commentParameter =
		commentPermalinkId !== null && commentPermalinkId !== undefined
			? `, commentId: ${commentPermalinkId}`
			: '';

	const commentAmountParameter =
		commentParameter !== '' && commentAmount !== null && commentAmount !== undefined
			? `, commentAmount: ${commentAmount}`
			: '';

	const maxResultsParameter =
		commentParameter === '' && maxResults !== null && maxResults !== undefined
			? `, maxResults: ${maxResults}`
			: '';

	return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            totalCount
        }
    `;
};
